import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { InitializationWrapper } from '@planning/components'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useParams } from 'react-router'
import { ContainerHistoryHeader } from './components/Molecules/ContainerHistoryHeader'
import { ContainerHistoryTable } from './components/Molecules/ContainerHistoryTable'
import { ContainerHistoryViewStore } from './stores/ContainerHistoryViewStore'

export const ContainerHistoryPage = observer(() => {
  const theme = useMinimalsTheme()
  const params = useParams()

  const { containerItemStore } = usePlanningStore()

  const containerHistoryViewStore = useMemo(
    () => new ContainerHistoryViewStore(containerItemStore),
    [],
  )

  const id = params.id ? parseInt(params.id) : undefined

  const { loading } = useAsyncFetch(async () => {
    if (id) {
      await containerHistoryViewStore.fetch(id)
    }
  }, [containerItemStore, id])

  return (
    <InitializationWrapper isInitializing={loading}>
      <Box
        sx={{
          minHeight: '100%',
          bgcolor: theme.palette.grey[100],
        }}
      >
        <ContainerHistoryHeader
          containerNumber={containerHistoryViewStore.container?.data.number}
        />

        <Box padding={theme.customSpacing.m}>
          <ContainerHistoryTable
            containerTurnoverList={containerHistoryViewStore.containerTurnoverList}
          />
        </Box>
      </Box>
    </InitializationWrapper>
  )
})
